// removed by extract-text-webpack-plugin
module.exports = {"queryButton":"_34oFK _1-OXK _3Xg8b _2pX3d _3BXGR","queryButtonText":"_3tLw6 _3_vf0 LPShn _3ECbl","queryButtonCircle":"_3_vOI _1-OXK _3Xg8b _3ibIU iw2TU"};


//////////////////
// WEBPACK FOOTER
// ./components/QueryButton.css
// module id = 1161
// module chunks = 3